import React from 'react';
import { useRouter } from 'next/router';
import { getPageBySlug, getAllPagesSlugs } from '../lib/pages';
import StartaProject from '@/components/StartaProject';
import { GetStaticPaths, GetStaticProps } from 'next'
import { getSeoData  } from '../lib/seo';
import SEO from '@/components/SEO'
interface PageProps {
  page: any; 
  initialSeo:any;
}
type Slug = string;
type Slugs = Array<Slug>;

export default function Slug({ page, initialSeo }: PageProps) {
  return (
    <> 
     <SEO initialSeo={initialSeo}/>
      <section className='section all_pages header_gap'>
        <div className="container">
          <div className="page_title" data-aos="fade" data-aos-delay="100">
              <h1 className='f54'>{page?.title}</h1>
          </div>
          <div className="default_typo" dangerouslySetInnerHTML={{ __html: page?.content || '' }}></div>
        </div>
      </section>
      <StartaProject/>
    </>
  );
}

// export const getStaticPaths: GetStaticPaths = async () => {
//   const slugs: Slugs = await getAllPagesSlugs(); // Define the type for slugs

//   const filteredPaths = slugs.filter((slug: Slug) => !['home','services','our-works','industries','blogs','about','contact-us','faqs'].includes(slug));

//   const paths = filteredPaths.map((slug: Slug) => ({
//     params: { slug },
//   }));

//   return { paths, fallback: false };
// };

export const getStaticPaths: GetStaticPaths = async () => {
  const slugs: Slugs = await getAllPagesSlugs();

  const allowedPaths = ['about', 'blogs','contact-us','faqs','free-consultancy','home','industries','our-works','services','thank-you','why-us','site-map']; // Add only the allowed paths here

  const filteredPaths = slugs.filter((slug: Slug) => !allowedPaths.includes(slug));

  const paths = filteredPaths.map((slug: Slug) => ({
    params: { slug },
  }));

  return { paths, fallback: false };
};

export async function getStaticProps({ params }: { params: { slug: string } }) {
  const slug = params.slug;
  const page = await getPageBySlug(slug);
  const initialSeo = await getSeoData(slug);
  return {
    props: {
      page,
      initialSeo
    },
    revalidate: 60, 
  };
}

